import { render, staticRenderFns } from "./add-trainee-facility.vue?vue&type=template&id=cd546f1e&scoped=true"
import script from "./add-trainee-facility.vue?vue&type=script&lang=js"
export * from "./add-trainee-facility.vue?vue&type=script&lang=js"
import style0 from "./add-trainee-facility.vue?vue&type=style&index=0&id=cd546f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd546f1e",
  null
  
)

export default component.exports